import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type PaymentDefaultCardProps = {
    className?: string;
};

const PaymentDefaultCard: FunctionComponent<PaymentDefaultCardProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'payment-default-card'}
            viewBox="0 0 500 312"
        >
            <path d="M0 0v312h500V0H0zm51.7 74.8c0-2.8 2.2-5 5-5h136.7c2.8 0 5 2.2 5 5v72.3c0 2.8-2.2 5-5 5H56.7c-2.8 0-5-2.2-5-5V74.8zM135 266.9c0 2.8-2.2 5-5 5H55.6c-2.8 0-5-2.2-5-5v-42.6c0-2.8 2.2-5 5-5H130c2.8 0 5 2.2 5 5v42.6zm104.4 0c0 2.8-2.2 5-5 5H160c-2.8 0-5-2.2-5-5v-42.6c0-2.8 2.2-5 5-5h74.3c2.8 0 5 2.2 5 5v42.6zm104.4 0c0 2.8-2.2 5-5 5h-74.3c-2.8 0-5-2.2-5-5v-42.6c0-2.8 2.2-5 5-5h74.3c2.8 0 5 2.2 5 5v42.6zm104.4 0c0 2.8-2.2 5-5 5h-74.3c-2.8 0-5-2.2-5-5v-42.6c0-2.8 2.2-5 5-5h74.3c2.8 0 5 2.2 5 5v42.6z" />
        </svg>
    );
};

export default PaymentDefaultCard;
